import {
  COMMANDER_DUTIES,
  COMMANDER_STANDARDS,
  COMPANY_TREE,
} from "./data/DiscordPageData";

const TEAMS_PER_PROJECT = 3;

export default function DiscordCommander() {
  return (
    <>
      {/* ── COMMANDER SPOTLIGHT ──────────────────────────────────── */}
      <section className="dsc-section" id="commander">
        <div className="dsc-eyebrow">Spotlight</div>
        <h2 className="dsc-h2">
          The <span className="gold">Commander</span>
        </h2>
        <p className="dsc-section-sub dsc-wide">
          Every company grows from a single Commander. They sit above the
          Project Captains, answer to the Software Engineers, and are the final
          word on direction, deadlines and discipline for everything beneath
          them.
        </p>

        <div className="dsc-cmd-layout">
          {/* Company diagram */}
          <div className="dsc-company" aria-label="Company structure">
            <div className="dsc-company-label">One company, top to bottom</div>

            <div className="dsc-co-node dsc-co-cmd">
              <img
                src="/community/roles/commander.png"
                alt=""
                className="dsc-co-img"
                loading="lazy"
              />
              <div>
                <strong>Commander</strong>
                <small>Leads the company</small>
              </div>
            </div>
            <div className="dsc-co-line" />

            <div className="dsc-co-projects">
              {COMPANY_TREE.projects.map((p) => (
                <div key={p.label} className="dsc-co-branch">
                  <div className="dsc-co-node dsc-co-pc">
                    <img
                      src="/community/roles/projectCaptain.png"
                      alt=""
                      className="dsc-co-img"
                      loading="lazy"
                    />
                    <div>
                      <strong>Project Captain</strong>
                      <small>{p.label}</small>
                    </div>
                  </div>
                  <div className="dsc-co-line short" />
                  <div className="dsc-co-teams">
                    {Array.from({ length: TEAMS_PER_PROJECT }, (_, i) => (
                      <div key={i} className="dsc-co-node dsc-co-tc">
                        <img
                          src="/community/roles/teamCaptain.png"
                          alt=""
                          className="dsc-co-img sm"
                          loading="lazy"
                        />
                        <div>
                          <strong>Team Captain</strong>
                          <small>5 members</small>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="dsc-co-note">{p.note}</div>
                </div>
              ))}
            </div>

            <div className="dsc-co-total">
              Roughly <strong>1 + 2 + 6 + 30 = 39 people</strong> in one
              illustrative company
            </div>
          </div>

          {/* Duties */}
          <div className="dsc-duties">
            {COMMANDER_DUTIES.map((d) => (
              <div key={d.title} className="dsc-duty">
                <div className="dsc-duty-icon" aria-hidden>
                  {d.icon}
                </div>
                <div>
                  <div className="dsc-duty-title">{d.title}</div>
                  <p className="dsc-duty-text">{d.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="dsc-standards">
          <div className="dsc-standards-head">What a Commander is held to</div>
          <ul className="dsc-standards-list">
            {COMMANDER_STANDARDS.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
